module.exports = __webpack_public_path__ + "static/media/12UNCTAD19.02e45748.jpg";